import MealPlanAssignmentsTable from './MealPlanAssignmentsTable';

export default MealPlanAssignmentsTable;
